<template>
  <div
    class="flex justify-between items-center py-2 border-b last:border-b-0 text-sm text-gray-700 border-gray-100 px-2"
  >
    <span :class="labelClasses" v-html="label"></span>
    <span class="flex items-center">
      <slot></slot>
    </span>
  </div>
</template>

<script>
/* eslint-disable vue/require-prop-type-constructor */
export default {
  props: {
    label: "",
    labelClasses: "",
  },
};
</script>
